/* ============================================================
   BITE ESSENCE — theme.js
   Hero slider · Cart drawer · Mobile menu · Add to cart
   ============================================================ */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     UTILS
  ───────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  var toastTimer;
  function showToast(msg) {
    var t = qs('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }

  /* ─────────────────────────────────────────
     HERO SLIDER
  ───────────────────────────────────────── */
  window.BiteHeroSlider = (function () {
    var instances = {};

    function Slider(sectionId) {
      var self = this;
      self.id = sectionId;
      self.el = qs('#hero-slider-' + sectionId);
      if (!self.el) return;

      self.track = qs('#slides-track-' + sectionId);
      self.dotsWrap = qs('#hero-dots-' + sectionId);
      self.progressBar = qs('#hero-progress-' + sectionId);
      self.slides = qsa('.slide', self.el);
      self.total = self.slides.length;
      self.current = 0;
      self.autoplay = self.el.dataset.autoplay !== 'false';
      self.speed = parseInt(self.el.dataset.speed, 10) || 5000;
      self.timer = null;
      self.progressTimer = null;
      self.touchStartX = 0;
      self.isAnimating = false;

      if (self.total <= 1) return;

      self._buildDots();
      self._bindArrows();
      self._bindTouch();
      self._bindKeys();
      if (self.autoplay) self._start();
    }

    Slider.prototype._buildDots = function () {
      var self = this;
      if (!self.dotsWrap) return;
      self.dotsWrap.innerHTML = '';
      self.slides.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.className = 'hero-dot' + (i === 0 ? ' active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.addEventListener('click', function () { self._goTo(i); self._restart(); });
        self.dotsWrap.appendChild(btn);
      });
    };

    Slider.prototype._updateDots = function () {
      var self = this;
      if (!self.dotsWrap) return;
      qsa('.hero-dot', self.dotsWrap).forEach(function (d, i) {
        d.classList.toggle('active', i === self.current);
      });
    };

    Slider.prototype._bindArrows = function () {
      var self = this;
      var prev = qs('.hero-arrow-prev', self.el);
      var next = qs('.hero-arrow-next', self.el);
      if (prev) prev.addEventListener('click', function () { self._step(-1); self._restart(); });
      if (next) next.addEventListener('click', function () { self._step(1); self._restart(); });
    };

    Slider.prototype._bindTouch = function () {
      var self = this;
      self.el.addEventListener('touchstart', function (e) {
        self.touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      self.el.addEventListener('touchend', function (e) {
        var diff = self.touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) self._step(diff > 0 ? 1 : -1);
      }, { passive: true });
    };

    Slider.prototype._bindKeys = function () {
      var self = this;
      document.addEventListener('keydown', function (e) {
        if (!self.el.matches(':hover')) return;
        if (e.key === 'ArrowLeft') self._step(-1);
        if (e.key === 'ArrowRight') self._step(1);
      });
    };

    Slider.prototype._goTo = function (idx) {
      var self = this;
      self.current = ((idx % self.total) + self.total) % self.total;
      self.track.style.transform = 'translateX(-' + self.current * 100 + '%)';
      self._updateDots();
      self._resetProgress();

      // update aria
      self.slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i !== self.current ? 'true' : 'false');
      });
    };

    Slider.prototype._step = function (dir) {
      this._goTo(this.current + dir);
    };

    Slider.prototype._resetProgress = function () {
      var self = this;
      if (!self.progressBar) return;
      self.progressBar.style.transition = 'none';
      self.progressBar.style.width = '0%';
      clearTimeout(self.progressTimer);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          self.progressBar.style.transition = 'width ' + self.speed + 'ms linear';
          self.progressBar.style.width = '100%';
        });
      });
    };

    Slider.prototype._start = function () {
      var self = this;
      self._resetProgress();
      self.timer = setInterval(function () { self._step(1); }, self.speed);
    };

    Slider.prototype._restart = function () {
      clearInterval(this.timer);
      this._start();
    };

    Slider.prototype.pause = function () { clearInterval(this.timer); };
    Slider.prototype.resume = function () { if (this.autoplay) this._start(); };

    return {
      init: function (sectionId) {
        if (!instances[sectionId]) {
          instances[sectionId] = new Slider(sectionId);
        }
      },
      initAll: function () {
        qsa('.hero-slider').forEach(function (el) {
          var id = el.id.replace('hero-slider-', '');
          if (id) BiteHeroSlider.init(id);
        });
      }
    };
  })();

  /* ─────────────────────────────────────────
     MOBILE MENU
  ───────────────────────────────────────── */
  var BiteMenu = (function () {
    var menuEl = qs('#mobile-menu');
    var toggle = qs('#menu-toggle');
    var closeBtn = qs('#menu-close');
    var backdrop = qs('#menu-backdrop');

    function open() {
      if (!menuEl) return;
      menuEl.classList.add('is-open');
      if (toggle) { toggle.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); }
      menuEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!menuEl) return;
      menuEl.classList.remove('is-open');
      if (toggle) { toggle.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
      menuEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (toggle) toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // close menu on nav link click (mobile)
    if (menuEl) {
      qsa('a', menuEl).forEach(function (a) {
        a.addEventListener('click', close);
      });
    }

    return { open: open, close: close };
  })();

  /* ─────────────────────────────────────────
     CART — AJAX
  ───────────────────────────────────────── */
  window.BiteCart = (function () {

    var drawerEl   = qs('#cart-drawer');
    var backdropEl = qs('#cart-backdrop');
    var bodyEl     = qs('#drawer-body');
    var footEl     = qs('#drawer-foot');
    var badgeEl    = qs('#cart-badge');
    var cartTrigger = qs('#cart-trigger');
    var cartClose   = qs('#cart-close');
    var keepBtn     = qs('#cart-keep-shopping');

    /* open / close */
    function openDrawer() {
      if (!drawerEl) return;
      fetchAndRender();
      drawerEl.classList.add('is-open');
      drawerEl.setAttribute('aria-hidden', 'false');
      backdropEl && backdropEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawerEl) return;
      drawerEl.classList.remove('is-open');
      drawerEl.setAttribute('aria-hidden', 'true');
      backdropEl && backdropEl.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (cartTrigger) cartTrigger.addEventListener('click', openDrawer);
    if (cartClose)   cartClose.addEventListener('click', closeDrawer);
    if (backdropEl)  backdropEl.addEventListener('click', closeDrawer);
    if (keepBtn)     keepBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    /* badge update */
    function updateBadge(count) {
      if (!badgeEl) return;
      badgeEl.textContent = count;
      badgeEl.classList.toggle('show', count > 0);
    }

    /* fetch cart JSON */
    function getCart() {
      return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    /* render drawer from cart object */
    function renderDrawer(cart) {
      if (!bodyEl || !footEl) return;
      updateBadge(cart.item_count);

      if (cart.item_count === 0) {
        bodyEl.innerHTML = [
          '<div class="drawer-empty-state">',
          '<div class="drawer-empty-icon">🛒</div>',
          '<p>Your cart is empty.</p>',
          '<a href="/collections/all" class="slide-cta" style="padding:12px 28px;font-size:11px;display:inline-block">Shop Now</a>',
          '</div>'
        ].join('');
        footEl.innerHTML = '';
        return;
      }

      var itemsHtml = cart.items.map(function (item) {
        var imgHtml = item.image
          ? '<img src="' + item.image + '" alt="' + escAttr(item.title) + '" width="58" height="58" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
          : '<span style="font-size:22px">' + item.title.charAt(0) + '</span>';

        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? item.variant_title + ' · '
          : '';

        return [
          '<div class="drawer-item" data-key="' + item.key + '">',
          '  <div class="di-img">' + imgHtml + '</div>',
          '  <div style="flex:1;min-width:0">',
          '    <div class="di-name">' + esc(item.product_title) + '</div>',
          '    <div class="di-sub">' + variantTitle + formatMoney(item.price) + '</div>',
          '    <div class="di-bottom">',
          '      <div class="di-qty">',
          '        <button class="qty-minus" data-key="' + item.key + '" aria-label="Decrease">−</button>',
          '        <span class="qty-num">' + item.quantity + '</span>',
          '        <button class="qty-plus" data-key="' + item.key + '" aria-label="Increase">+</button>',
          '      </div>',
          '      <div class="di-price">' + formatMoney(item.line_price) + '</div>',
          '    </div>',
          '    <button class="di-remove" data-key="' + item.key + '">Remove</button>',
          '  </div>',
          '</div>'
        ].join('');
      }).join('');

      bodyEl.innerHTML = itemsHtml;
      bindDrawerEvents();

      var FREE_THRESHOLD = 99900; // ₹999 in paise
      var shipping = cart.total_price >= FREE_THRESHOLD ? 0 : 6000;
      var shippingMsg = shipping === 0
        ? '✓ Free shipping applied!'
        : 'Add ' + formatMoney(FREE_THRESHOLD - cart.total_price) + ' more for free shipping';

      footEl.innerHTML = [
        '<div class="drawer-subtotal">',
        '  <span class="lbl">Subtotal</span>',
        '  <span class="amt">' + formatMoney(cart.total_price) + '</span>',
        '</div>',
        '<div class="drawer-ship-note">' + shippingMsg + '</div>',
        '<a href="/checkout" class="drawer-checkout-btn">',
        '  Checkout — ' + formatMoney(cart.total_price + shipping),
        '</a>',
        '<button class="drawer-keep-btn" id="cart-keep-shopping">Continue Shopping</button>'
      ].join('');

      var keepNew = qs('#cart-keep-shopping');
      if (keepNew) keepNew.addEventListener('click', closeDrawer);
    }

    /* bind qty / remove events inside drawer */
    function bindDrawerEvents() {
      if (!bodyEl) return;
      bodyEl.addEventListener('click', function (e) {
        var key;
        if (e.target.classList.contains('qty-plus')) {
          key = e.target.dataset.key;
          changeQty(key, 1);
        } else if (e.target.classList.contains('qty-minus')) {
          key = e.target.dataset.key;
          changeQty(key, -1);
        } else if (e.target.classList.contains('di-remove')) {
          key = e.target.dataset.key;
          changeQty(key, -999);
        }
      });
    }

    /* fetch + render */
    function fetchAndRender() {
      getCart().then(renderDrawer).catch(function (err) {
        console.error('[BiteCart] fetch error:', err);
      });
    }

    /* change qty of a line item */
    function changeQty(key, delta) {
      // get current qty from DOM
      var row = qs('[data-key="' + key + '"].drawer-item', bodyEl);
      var currentQty = row ? parseInt(qs('.qty-num', row).textContent, 10) : 0;
      var newQty = Math.max(0, currentQty + delta);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (r) { return r.json(); })
        .then(renderDrawer)
        .catch(function (err) { console.error('[BiteCart] changeQty error:', err); });
    }

    /* add item to cart */
    function addItem(variantId, quantity, title, price, btn) {
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status === 422 || item.errors) {
            showToast('Sorry — item unavailable');
            if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
            return;
          }
          if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
          openDrawer();
          showToast((title || item.title) + ' added ✓');
        })
        .catch(function (err) {
          console.error('[BiteCart] addItem error:', err);
          if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
          showToast('Could not add item — please try again');
        });
    }

    /* initialise badge from page load */
    function init() {
      getCart().then(function (cart) { updateBadge(cart.item_count); });
    }

    return { open: openDrawer, close: closeDrawer, addItem: addItem, init: init };
  })();

  /* ─────────────────────────────────────────
     PRODUCT FORM — add to cart on product page
  ───────────────────────────────────────── */
  var BiteProductForm = (function () {
    function init() {
      var forms = qsa('form[action="/cart/add"]');
      forms.forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var variantInput = qs('[name="id"]', form);
          var qtyInput = qs('[name="quantity"]', form);
          var titleEl = qs('.product-title', form.closest('.product-main') || document);
          var btn = qs('[type="submit"]', form);

          if (!variantInput) return;
          var variantId = parseInt(variantInput.value, 10);
          var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
          var title = titleEl ? titleEl.textContent.trim() : '';

          BiteCart.addItem(variantId, qty, title, '', btn);
        });
      });
    }
    return { init: init };
  })();

  /* ─────────────────────────────────────────
     HORIZONTAL SCROLL DOTS
     Updates .scroll-hint-dot active state
     as user scrolls product / review rows
  ───────────────────────────────────────── */
  var BiteScrollDots = (function () {
    function bindRow(scrollEl, dotsEl) {
      if (!scrollEl || !dotsEl) return;
      var dots = qsa('.scroll-hint-dot', dotsEl);
      if (!dots.length) return;

      var cardWidth = scrollEl.firstElementChild
        ? scrollEl.firstElementChild.offsetWidth + 12
        : 222;

      scrollEl.addEventListener('scroll', function () {
        var idx = Math.round(scrollEl.scrollLeft / cardWidth);
        idx = Math.min(idx, dots.length - 1);
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }, { passive: true });
    }

    function init() {
      // products
      qsa('.products-scroll').forEach(function (el) {
        var section = el.closest('[data-section-id]');
        if (!section) return;
        var sId = section.dataset.sectionId;
        var dotsEl = qs('#scroll-hint-' + sId);
        bindRow(el, dotsEl);
      });

      // reviews
      qsa('.reviews-scroll').forEach(function (el) {
        var dotsEl = el.nextElementSibling;
        if (dotsEl && dotsEl.classList.contains('scroll-hint')) {
          bindRow(el, dotsEl);
        }
      });
    }
    return { init: init };
  })();

  /* ─────────────────────────────────────────
     STICKY HEADER — hide on scroll down,
     show on scroll up
  ───────────────────────────────────────── */
  var BiteHeader = (function () {
    var lastY = 0;
    var nav = qs('.site-nav');
    var threshold = 80;

    function onScroll() {
      if (!nav) return;
      var y = window.scrollY;
      if (y > threshold) {
        if (y > lastY) {
          nav.style.transform = 'translateY(-100%)';
        } else {
          nav.style.transform = 'translateY(0)';
        }
      } else {
        nav.style.transform = 'translateY(0)';
      }
      lastY = y;
    }

    function init() {
      if (!nav) return;
      nav.style.transition = 'transform 0.3s ease';
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    return { init: init };
  })();

  /* ─────────────────────────────────────────
     VARIANT SELECTOR — product page
  ───────────────────────────────────────── */
  var BiteVariants = (function () {
    function init() {
      qsa('.variant-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('.variant-group');
          if (group) {
            qsa('.variant-option', group).forEach(function (b) { b.classList.remove('active'); });
          }
          btn.classList.add('active');

          // update hidden input
          var form = btn.closest('form');
          if (form) {
            var idInput = qs('[name="id"]', form);
            if (idInput && btn.dataset.variantId) {
              idInput.value = btn.dataset.variantId;
            }
          }
        });
      });
    }
    return { init: init };
  })();

  /* ─────────────────────────────────────────
     QUANTITY SELECTOR — product page
  ───────────────────────────────────────── */
  var BiteQty = (function () {
    function init() {
      qsa('.qty-minus, .qty-plus').forEach(function (btn) {
        if (btn.closest('.di-qty')) return; // skip drawer
        btn.addEventListener('click', function () {
          var input = qs('[name="quantity"]', btn.closest('.qty-wrap') || btn.closest('form'));
          if (!input) return;
          var val = parseInt(input.value, 10) || 1;
          if (btn.classList.contains('qty-plus')) {
            input.value = val + 1;
          } else {
            input.value = Math.max(1, val - 1);
          }
        });
      });
    }
    return { init: init };
  })();

  /* ─────────────────────────────────────────
     SECTION ANNOUNCEMENTS (theme editor)
     Handles show/hide when toggled in the
     Shopify customiser.
  ───────────────────────────────────────── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sectionEl = e.target;
      // re-init slider if it's a hero slider section
      var slider = qs('.hero-slider', sectionEl);
      if (slider) {
        var id = slider.id.replace('hero-slider-', '');
        if (id) window.BiteHeroSlider.init(id);
      }
    });
    document.addEventListener('shopify:block:select', function (e) {
      // jump to the selected slide when a block is selected in the editor
      var block = e.target;
      var sliderEl = block.closest('.hero-slider');
      if (!sliderEl) return;
      var id = sliderEl.id.replace('hero-slider-', '');
      var slideIdx = parseInt(block.dataset.slideIndex, 10);
      if (!isNaN(slideIdx) && window.BiteHeroSlider) {
        var inst = window.BiteHeroSlider._getInstance && window.BiteHeroSlider._getInstance(id);
        if (inst) inst._goTo(slideIdx);
      }
    });
  }

  /* ─────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────── */
  function formatMoney(cents) {
    // Shopify stores prices in paise for INR
    return '₹' + (cents / 100).toFixed(0);
  }
  function esc(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function escAttr(str) {
    return String(str).replace(/"/g, '&quot;');
  }

  /* ─────────────────────────────────────────
     BOOT
  ───────────────────────────────────────── */
  function boot() {
    BiteHeroSlider.initAll();
    BiteCart.init();
    BiteProductForm.init();
    BiteScrollDots.init();
    BiteHeader.init();
    BiteVariants.init();
    BiteQty.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
